import React from "react";
import { MutatingDots } from "react-loader-spinner";

export default function Loader({ sx, color = "#38B3F6" }) {
  return (
    <MutatingDots
      visible={true}
      height="100"
      width="100"
      color={color}
      secondaryColor={color}
      radius="12.5"
      ariaLabel="mutating-dots-loading"
      wrapperStyle={{ ...sx }}
    />
  );
}
